import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  Box,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';

const ResetPasswordPage = () => {
  const [form, setForm] = useState({
    email: '',
    resetPassVerifyCode: '',
    password: '',
    confirmPassword: '',
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendCode = async () => {
    setLoading(true);
    try {
      const res = await api.post('/auth/user/reset/password/mail/send', {
        email: form.email,
      });
      setMessage('✅ Code sent: ' + res.data.status);
      setError('');
    } catch (err: any) {
      setError('❌ Code send failed: ' + (err.response?.data?.message || err.message));
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (form.password !== form.confirmPassword) {
      setError('❌ Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/auth/user/reset/password/mail', form);
      setMessage('✅ Password reset: ' + res.data.status);
      setError('');
      handleGoBack();
    } catch (err: any) {
      setError('❌ Password reset failed: ' + (err.response?.data?.message || err.message));
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <>
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Reset Password
          </Typography>
          <TextField
            label="Email"
            name="email"
            fullWidth
            margin="normal"
            onChange={handleChange}
          />
          <Button onClick={sendCode}>Send Code</Button>
          <TextField
            label="Verify Code"
            name="resetPassVerifyCode"
            fullWidth
            margin="normal"
            onChange={handleChange}
          />
          <TextField
            label="New Password"
            name="password"
            type="password"
            fullWidth
            margin="normal"
            onChange={handleChange}
          />
          <TextField
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            margin="normal"
            onChange={handleChange}
          />
          <Box display="flex" gap={2} mt={2}>
            <Button variant="contained" onClick={handleSubmit}>
              Update Password
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleGoBack}>
              Go Back
            </Button>
          </Box>
          {message && (
            <Typography sx={{ mt: 2 }} color="success.main">
              {message}
            </Typography>
          )}
          {error && (
            <Typography sx={{ mt: 2 }} color="error">
              {error}
            </Typography>
          )}
        </Paper>
      </Container>

      {/* Loading Ekranı */}
      <Backdrop
        open={loading}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ResetPasswordPage;